import { IPrebidConfiguration } from "@almamedia/amr-adtech-stack/lib/services/prebid/prebid";

const prebid: IPrebidConfiguration = {
  enabled: true,
  defaults: {
    prebidTimeout: 800,
    rubicon: {
      singleRequest: true,
      accountId: "10101",
      siteId: "36508",
    },
  },
  userSync: {
    syncDelay: 3000,
    userIds: [
      {
        name: "pubCommonId",
        bidders: ["adform", "rubicon"],
        storage: {
          type: "cookie",
          name: "_pubcid",
          expires: 60,
        },
      },
    ],
  },
  bids: {
    ros_almad_parade_1: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "301818",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050769",
          },
        },
      ],
    },
    ros_almad_parade_2: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "151360",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050770",
          },
        },
      ],
    },
    ros_almad_list_1: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "432976",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050771",
          },
        },
      ],
    },
    ros_almad_list_2: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "196276",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050772",
          },
        },
      ],
    },
    ros_almad_list_3: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056900",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050773",
          },
        },
      ],
    },
    ros_almad_rectangle_1: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056902",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050774",
          },
        },
      ],
    },
    ros_almad_skyscraper_1: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "151362",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050775",
          },
        },
      ],
    },
    ros_almad_mobile_parade_1: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056906",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050776",
          },
        },
      ],
    },
    ros_almad_mobile_parade_2: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056914",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050777",
          },
        },
      ],
    },
    ros_almad_mobile_list_1: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056920",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050778",
          },
        },
      ],
    },
    ros_almad_mobile_list_2: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056924",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050779",
          },
        },
      ],
    },
    ros_almad_mobile_list_3: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "2056926",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "1050782",
          },
        },
      ],
    },
    /*
    Etuovi_ROS_NordicParade: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "196276",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "76203",
          },
        },
      ],
    },
    Etuovi_ROS_MediumRectangle: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "151360",
          },
        },
        {
          bidder: "rubicon",
          params: {
            zoneId: "432976",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "76196",
          },
        },
      ],
    },
    Etuovi_ROS_WideSkyscraper: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            zoneId: "151362",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "76197",
          },
        },
      ],
    },
    Etuovi_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: {
            siteId: "71666",
            zoneId: "340912",
          },
        },
        {
          bidder: "adform",
          params: {
            mid: "82092",
          },
        },
      ],
    },
	*/
  },
};

export default prebid;
